import { useLanguageContext } from "../../../../context/LanguageContext";
import AzureConfigsPage from "../../../../pages/integrations/azure/AzureConfigsPage";
import { useAzureConfigsRouteValidator } from "../../../validators/integrations/azure/AzureConfigsRouteValidator";
import { RouteConfig } from "../../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useAzureConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/azure")
    .setLabel(translate("eva.main.entities.azure_config"))
    .setValidator(useAzureConfigsRouteValidator())
    .setPage(<AzureConfigsPage />);
}

export default useAzureConfigsRouteConfig;
